import { render, staticRenderFns } from "./TriggerDetail.vue?vue&type=template&id=1967c02e&scoped=true&"
import script from "./TriggerDetail.vue?vue&type=script&lang=js&"
export * from "./TriggerDetail.vue?vue&type=script&lang=js&"
import style0 from "./TriggerDetail.vue?vue&type=style&index=0&id=1967c02e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1967c02e",
  null
  
)

export default component.exports